import React, { useEffect, useState } from 'react'
import DynamicTable from "./DynamicTable";
import moment from 'moment';
import { get } from '../Services/services';

const SMSLogsPanel = ({ courseData }) => {
    const headCells = [
        { id: "sno", numeric: false, label: "S.no" },
        // { id: "title", numeric: false, label: "Title" },
        // { id: "module", numeric: false, label: "Module" },
        // { id: "event", numeric: true, label: "Event" },
        { id: "message", numeric: true, label: "Message" },
        { id: "mobile", numeric: true, label: "Mobile" },
        { id: "Admin", numeric: true, label: "Send By" },
        { id: "date", numeric: true, label: "Date" },
    ];
    
    const [smsLogs, setSmsLogs] = useState([]);
    const [dataSource, setDataSource] = useState([]);
    const [loading, setLoading] = useState(true);

    const fetchSmsLogs = async () => {
        try {
            setLoading(true);
            const courseId = courseData?._id;
            if (!courseId) {
                console.error("No course ID provided");
                setLoading(false);
                return;
            }
            
            const response = await get(`SmsLogs?filter[where][subscribedCoursesId]=${courseId}&filter[include]=admin`);
            console.log("SMS Logs response:", response);
            
            if (response && Array.isArray(response)) {
                setSmsLogs(response);
                const formattedData = await formatTableData(response);
                setDataSource(formattedData);
            } else if (response && response.data && Array.isArray(response.data)) {
                setSmsLogs(response.data);
                const formattedData = await formatTableData(response.data);
                setDataSource(formattedData);
            } else {
                console.error("Unexpected response format:", response);
                setDataSource([]);
            }
        } catch (error) {
            console.error("Failed to fetch SMS logs:", error);
            setDataSource([]);
        } finally {
            setLoading(false);
        }
    };

    const formatTableData = async (logs) => {
        return logs.map((log, index) => ({
            sno: index + 1,
            title: log.smsTemplateId?.title || 'N/A',
            module: log.smsTemplateId?.module || 'N/A',
            event: log.smsTemplateId?.event || 'N/A',
            message: log.message || 'N/A',
            mobile: log.mobile || 'N/A',
            Admin: log.admin?.name || 'System',
            date: log.createdAt ? moment(log.createdAt).format('DD/MM/YYYY HH:mm') : 'N/A'
        }));
    };

    useEffect(() => {
        fetchSmsLogs();
    }, [courseData?._id]); 

    return (
        <div className="w-full">
            {loading ? (
                <div className="flex justify-center items-center py-8">Loading SMS logs...</div>
            ) : (
                dataSource.length > 0 ? (
                    <DynamicTable
                        dataSource={dataSource}
                        headCells={headCells}
                    />
                ) : (
                    <div className="text-center py-8">No SMS logs found for this course</div>
                )
            )}
        </div>
    );
};

export default SMSLogsPanel;